// ============================================
// PRODUCT UIDs (Gelato - Platzhalter, echte Werte aus dem Gelato Dashboard)
// ============================================
export const PRODUCT_UIDS = {
    VISITENKARTE_STANDARD_MATTE: 'CARD_STD_MATTE',
    VISITENKARTE_STANDARD_GLANZ: 'CARD_STD_GLOSS',
    VISITENKARTE_PREMIUM_MATTE: 'CARD_PREM_MATTE',
    VISITENKARTE_PREMIUM_SOFTTOUCH: 'CARD_PREM_SOFT',
    VISITENKARTE_RUND: 'CARD_ROUND',
    VISITENKARTE_QUADRAT: 'CARD_SQUARE',
};
// Lookup von UID (Wert) → Produkt-Metadaten (Key)
export function getProductMeta(uid) {
    const key = Object.keys(PRODUCT_UIDS).find((k) => PRODUCT_UIDS[k] === uid);
    return key ? PRODUCT_META[key] : undefined;
}
export const PRODUCT_META = {
    VISITENKARTE_STANDARD_MATTE: {
        name: 'Standard Matte',
        description: 'Klassische Visitenkarte, matt',
        format: 'standard',
        paper: '350g',
        finish: 'matte',
        badge: 'bestseller',
    },
    VISITENKARTE_STANDARD_GLANZ: {
        name: 'Standard Glanz',
        description: 'Klassische Visitenkarte, glänzend',
        format: 'standard',
        paper: '350g',
        finish: 'gloss',
    },
    VISITENKARTE_PREMIUM_MATTE: {
        name: 'Premium Matte',
        description: 'Premium Visitenkarte, matt',
        format: 'standard',
        paper: '450g',
        finish: 'matte',
        badge: 'premium',
    },
    VISITENKARTE_PREMIUM_SOFTTOUCH: {
        name: 'Premium Softtouch',
        description: 'Premium Visitenkarte, Softtouch',
        format: 'standard',
        paper: '450g',
        finish: 'softtouch',
        badge: 'premium',
    },
    VISITENKARTE_RUND: {
        name: 'Rund',
        description: 'Runde Visitenkarte',
        format: 'round',
        paper: '350g',
        finish: 'matte',
    },
    VISITENKARTE_QUADRAT: {
        name: 'Quadratisch',
        description: 'Quadratische Visitenkarte',
        format: 'square',
        paper: '350g',
        finish: 'matte',
    },
};
// ============================================
// ORDER STATUS LABELS
// ============================================
export const ORDER_STATUS_LABELS = {
    draft: 'Entwurf',
    payment_pending: 'Zahlung ausstehend',
    pending: 'Ausstehend',
    quoted: 'Angebot erstellt',
    confirmed: 'Bestätigt',
    production: 'In Produktion',
    shipped: 'Versendet',
    delivered: 'Geliefert',
    cancelled: 'Storniert',
    failed: 'Fehlgeschlagen',
};
export const ORDER_STATUS_FLOW = [
    'draft',
    'payment_pending',
    'pending',
    'quoted',
    'confirmed',
    'production',
    'shipped',
    'delivered',
];
// ============================================
// R2 PREFIXES
// ============================================
export const R2_PREFIXES = {
    UPLOADS: 'uploads/',
    TEMPLATES: 'templates/',
    PREVIEWS: 'previews/',
    PRINT_FILES: 'print-files/',
    TEMP: 'temp/',
};
// ============================================
// VALIDATION LIMITS
// ============================================
export const LIMITS = {
    MAX_FILE_SIZE: 50 * 1024 * 1024, // 50 MB
    ALLOWED_MIME_TYPES: ['application/pdf', 'image/png', 'image/jpeg', 'image/tiff'],
    MAX_QUANTITY: 10000,
    MIN_QUANTITY: 1,
    SUPPORTED_CURRENCIES: ['EUR', 'USD', 'GBP'],
};
